// Sites admin (R-150) — cloud + admin only. Create/configure fleet sites centrally; mint the
// one-time enrollment token a local server uses to adopt its identity (zero-touch onboarding).
// DE drafted — queued for native review.
export const sites = {
  title: { de: 'Standorte', en: 'Sites' },
  desc: {
    de: 'Ihre Flotte — Server, die sich gemeldet haben, und die Standorte, die sie betreiben. Einen nicht zugewiesenen Server beanspruchen, um daraus einen Standort zu machen.',
    en: 'Your fleet — servers that phoned home and the sites they run. Claim an unclaimed server to turn it into a site.',
  },

  add: { de: 'Standort hinzufügen', en: 'Add Site' },
  colActions: { de: 'Aktionen', en: 'Actions' },
  newSite: { de: 'Neuer Standort', en: 'New Site' },
  editSite: { de: 'Standort bearbeiten', en: 'Edit site' },
  phName: { de: 'z. B. Nexus Farm Dubai', en: 'e.g. Nexus Farm Dubai' },
  phCode: { de: 'Leer = aus dem Namen erzeugt', en: 'Blank = derived from the name' },
  phAddress: { de: 'z. B. 10.255.254.240:80', en: 'e.g. 10.255.254.240:80' },
  // Optional/secondary path — assign-by-address is the default. This mints the fallback token.
  enroll: { de: 'Token', en: 'Token' },

  colCode: { de: 'Code', en: 'Code' },
  colName: { de: 'Name', en: 'Name' },
  colAddress: { de: 'Adresse', en: 'Address' },

  codeHint: {
    de: 'Leer lassen — der Code wird aus dem Namen erzeugt („Some Site" → SS). Eigener Code nur, wenn eine Konvention besteht.',
    en: 'Leave blank — the code is derived from the name (“Some Site” → SS). Type one only to keep an existing convention.',
  },
  // ⚠ The server REFUSES a code change (400): it prefixes every location code beneath
  // the site, and those are retained MQTT topic levels. Renaming is fine; re-coding is not.
  codePermanent: {
    de: 'Dauerhaft — der Code ist die Kennung jedes Standorts darunter und kann nicht geändert werden. Der Name schon.',
    en: 'Permanent — the code is the identity of every location beneath this site and cannot be changed. The name can.',
  },
  addressHint: {
    de: 'Erreichbare host:port des lokalen Servers (SERVER_ADDRESS). Der Server mit genau dieser Adresse übernimmt den Standort automatisch — kein Token nötig.',
    en: 'The local server’s reachable host:port (its SERVER_ADDRESS). The server with exactly this address claims the site automatically — no token needed.',
  },

  emptyTitle: { de: 'Noch keine Server oder Standorte', en: 'No servers or sites yet' },
  emptyMsg: {
    de: 'Starten Sie einen lokalen Server mit gesetzter CLOUD_REGISTER_URL — er meldet sich hier und kann dann beansprucht werden. Oder legen Sie manuell einen Standort an.',
    en: 'Start a local server with CLOUD_REGISTER_URL set — it appears here to be claimed. Or add a site manually.',
  },
  loadError: { de: 'Standorte konnten nicht geladen werden', en: 'Could not load sites' },

  toastCreated: { de: 'Standort angelegt', en: 'Site created' },
  toastUpdated: { de: 'Standort aktualisiert', en: 'Site updated' },
  toastCopied: { de: 'Token kopiert', en: 'Token copied' },

  enrollTitle: { de: 'Registrierungs-Token (Alternative)', en: 'Enrollment token (alternative)' },
  enrollIntro: {
    de: 'Normalerweise nicht nötig: Setzen Sie einfach die Standort-Adresse auf die SERVER_ADDRESS des Servers. Falls Sie stattdessen ein Token verwenden möchten, fügen Sie diese Zeile in die .env von {site} ein und starten Sie den Server einmalig neu.',
    en: 'Usually unnecessary — just set this site’s address to the server’s SERVER_ADDRESS. If you’d rather use a token instead, paste this line into {site}’s .env and (re)start the server once.',
  },
  envLine: { de: 'Env-Zeile (einmalig sichtbar)', en: 'Env line (shown once)' },
  enrollWarn: {
    de: '⚠ Wird nur einmal angezeigt und ist einmalig gültig (Ablauf in 24 Stunden). Bei Verlust neu ausstellen.',
    en: '⚠ Shown once, single-use, expires in 24 hours. Re-issue if lost.',
  },
  done: { de: 'Fertig', en: 'Done' },
} as const;
